/** @format */

import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  loading: false,
  error: '',
  list: []
});

export default function pollingIntervals(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'LOAD_POLLING_INTERVALS_STARTED': {
      return state.set('loading', true);
    }
    case 'LOAD_POLLING_INTERVALS_DONE': {
      return state.set('list', fromJS(action.payload)).set('loading', false);
    }
    case 'LOAD_POLLING_INTERVALS_FAILED': {
      return state.set('error', action.payload.msg).set('loading', false);
    }
    default: {
      return state;
    }
  }
}
